import React from "react";
import styled from "../../lib/styled";
import { Layer } from "grommet";
import { FaTimes } from "react-icons/fa";

interface GalleryImageProps {
  name: string;
  image: string;
  description: string;
  productUrl: string;
}
export const ShopProduct: React.FC<GalleryImageProps> = (props) => {
  const [show, setShow] = React.useState<boolean>(false);

  return (
    <>
      <ProductWrapper onClick={() => setShow(true)}>
        <CoverImage src={props.image} />
        <ProductName>{props.name}</ProductName>
      </ProductWrapper>
      {show && (
        <ProductLightbox
          onEsc={() => setShow(false)}
          onClickOutside={() => setShow(false)}
        >
          <CloseIcon onClick={() => setShow(false)}>
            <FaTimes />
          </CloseIcon>
          <ProductImage src={props.image} />
          <ProductArea>
            <ProductTitle>{props.name}</ProductTitle>
            <ProductDescription>{props.description}</ProductDescription>
            <ProductLink href={props.productUrl} target="_blank">
              Go to product
            </ProductLink>
          </ProductArea>
        </ProductLightbox>
      )}
    </>
  );
};

const ProductLightbox = styled(Layer)`
  max-height: 90vh;
  max-width: 90vw;
  overflow: hidden;

  @media (max-width: 768px) {
    max-height: 100vh;
    max-width: 100vw;
    flex-direction: row;
  }
`;

const CloseIcon = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  padding: 10px;
  cursor: pointer;
`;
const ProductWrapper = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-bottom: 15px;
`;

const ProductName = styled.div`
  z-index: 10;
  font-size: 14px;
  font-family: "Keep Calm";
  letter-spacing: 2px;
  text-transform: uppercase;
  text-align: center;
`;

const ProductTitle = styled.h3`
  font-family: "Keep Calm";
  letter-spacing: 2px;
  text-transform: uppercase;
  padding-bottom: 10px;
`;

const ProductArea = styled.div`
  padding: 10px;
  max-width: 300px;
`;
const ProductDescription = styled.div``;
const ProductLink = styled.a`
  display: inline-block;
  font-family: "Keep Calm";
  letter-spacing: 2px;
  text-transform: uppercase;
  border-radius: 2px;
  background-color: ${({ theme }) => theme.color.accent};
  color: white;
  padding: 8px 10px;
  margin: 10px 0;
  font-size: 12px;
`;

const CoverImage = styled.img`
  width: 100%;
  height: auto;
  margin-bottom: 10px;
`;

const ProductImage = styled.img`
  margin: 0;
  height: 300px;
  width: 300px;
`;
